<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="130px">
      <el-form-item
        :label="title1 + '姓名:'"
        prop="staffName">
        <el-input
          v-model="ruleForm.staffName"
          maxlength="16"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item
        :label="title1+ '账号:'"
        prop="account">
        <el-input
          v-if="!ruleForm.staffId"
          v-model="ruleForm.account"
          maxlength="18"
          show-word-limit></el-input>
        <span v-else>{{ ruleForm.account }}</span>
      </el-form-item>
    </el-form>
    <el-alert
      title="默认密码：123456"
      type="success"
      :closable="false"> </el-alert>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Wms from '@/service/wms'
import { mapState } from 'vuex'
export default {
  name: 'WarehouseManagementEditModal',
  props: {
    operType: { type: Number, default: 60 },
    title1: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { staffId: null, account: '', staffName: '', userType: 506 },
      rules: {
        staffName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { pattern: /^[0-9a-zA-Z]{6,18}$/, message: '请输入账号,0-9,A-Z,a-z,长度6-18', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title({ ruleForm, title1 }) {
      return (ruleForm.staffId ? '修改' : '新增') + title1 + '账号'
    },
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  methods: {

    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.ruleForm.staffId ? 'updatestaff' : 'addstaff'
          this.loading = true
          Wms[dispatch]({ ...this.ruleForm, orgId: this.userInfo.orgId, operType: this.operType })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.visible = false
                this.$message.success('提交成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
